// extracted by mini-css-extract-plugin
module.exports = {"last-select-item":"styles-module__last-select-item___2pYOe"};